import React, { Suspense, useRef } from 'react';

/**
 * Использовать только для lazy load на клиенте. То есть для компонентов, которых ТОЧНО не может быть в серверном рендере. Например, модлаки.
 * Если использовать этот lazy load для импорта компонентов, которые должны быть отрендерены сразу, то он не будет включён в серверный бандл и может возникнуть проблема гидратации
 * Чтобы выделить в отдельный чанк какой-либо компонент, который должен отрендериться и на сервере и на клиенте нужно использовать webpack splitChunks
 * Но не стоит выделять много чанков при загрузке страницы. Это может увеличить время загрузки страницы
 * В splitChunks уже выделено vendors, beef, shared
 */
export const safeLazy = (asyncImport, options) =>
  typeof window !== 'undefined' ?
    () => {
      const Component = useRef(React.lazy(asyncImport)).current;

      return (
        <Suspense fallback={options?.fallback || <div />}>
          <Component />
        </Suspense>
      );
    }
  : () => {
      // eslint-disable-next-line max-len
      throw Error(
        "You mustn't use React.lazy for initial render, only for deferred render(modals, components dependent on fetched data)",
      );
    };
